import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { PortalStoreService } from 'src/app/core/store/services/portal-store.service';
import { makeThumbUrl } from 'src/app/core/utils/dom-utils';

@Component({
  selector: 'craft-portal-logo',
  templateUrl: './craft-portal-logo.component.html',
  styleUrls: ['./craft-portal-logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CraftPortalLogoComponent implements OnInit, OnDestroy {
  public name: string;
  public logoUrl: string | undefined;
  private logoSub: Subscription;

  constructor(
    private portalStore: PortalStoreService,
    private cdRef: ChangeDetectorRef,
  ) {}

  public ngOnInit() {
    this.logoSub = this.portalStore.portal$.pipe(filter((p) => !!p)).subscribe((portal) => {
      this.name = portal!.name;
      this.logoUrl = makeThumbUrl(portal!.logoId, 200);
      this.cdRef.detectChanges();
    });
  }

  public ngOnDestroy() {
    this.logoSub.unsubscribe();
  }
}
